/** Message type for RN host — must match bedbooking_react_native `useWebViewNavigateMessage`. */
export const BB_NAVIGATE = 'BB_NAVIGATE'
